/** Задержка от запроса на открытие, до открытия */
export var ENTER_DELAY = 100;
/** Задержка от запроса на закрытие, до закрытия */
export var LEAVE_DELAY = 0;
/** Задержка по окончанию тапа, через которую подсказка закрывается */
export var LEAVE_TOUCH_DELAY = 1500;
/** Задержка от начала тапа, через которую подсказка открывается */
export var TOUCH_DELAY = 700;
/** Дополнительная задержка, в течение которой открытие новых тултипов происходит без задержки */
export var HYSTERSIS_DELAY = 800;